















































import Vue, { PropType } from 'vue'
import { ValidationObserver } from 'vee-validate'
import type { Elements, Element, FormState, FormLabels, FormSubmitObject } from './UiForm.types'
import UiFormFieldList from './UiFormFieldList'
import UiFormCta from './UiFormCta'
import UiFieldset from '../UiFieldset'

export default Vue.extend({
  name: 'UiForm',
  components: {
    UiFormFieldList,
    ValidationObserver,
    UiFormCta,
    UiFieldset
  },
  props: {
    elements: {
      type: Array as PropType<Elements>,
      required: true
    },
    components: {
      type: [Object, Boolean],
      default: false
    },
    classes: {
      type: [Object, Boolean],
      default: false
    },
    state: {
      type: [Object, Boolean] as PropType<FormState>,
      default: false
    },
    i18n: {
      type: Object as PropType<FormLabels>,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {} as Record<string, string>
    }
  },
  computed: {
    validatorRef (): Vue & InstanceType<typeof ValidationObserver> {
      return this.$refs.validator as Vue & InstanceType<typeof ValidationObserver>
    },
    i18nVerifed (): FormLabels {
      const defaultTranslations: FormLabels = {
        submitButton: 'Submit',
        sendingLabel: 'Sending',
        serverError: 'We can not process form right now, please try again later.',
        validationErrors: 'There were some errors, review the form',
        requiredFields: 'Required fields',
        selectFileLabel: 'Select file',
        removeSelectedFileButton: 'Remove selected file',
        uploadButton: 'Upload attachment'
      }

      return Object.assign(defaultTranslations, this.i18n)
    }
  },
  beforeMount () {
    this.setupModel()
  },
  methods: {
    createModel (elements: Elements): Record<string, string> {
      const model: Record<string, string> = {}
      elements.forEach((element: Element) => {
        if (element.elements) {
          return Object.assign(model, this.createModelByFieldset(element.elements))
        }
        Object.assign(model, this.createModelByFieldset(elements))
      })
      return model
    },
    createModelByFieldset (elements: Elements): Record<string, string> {
      const fieldset: Record<string, string> = {}
      elements.forEach((element: Element) => {
        if (element.name) {
          fieldset[element.name] = element.defaultValue || ''
        }
      })
      return fieldset
    },
    setupModel () {
      if (this.elements.length) {
        this.model = this.createModel(this.elements)
      }
    },
    focusOnErrors () {
      const errors = Object.entries(this.validatorRef.refs)
        .map(([key, value]) => ({
          key,
          value
        }))
        .filter((error: any) => {
          return (!error || !error.value || !error.value.failedRules) ? false : Object.keys(error.value.failedRules).length > 0
        })
      if (errors && errors.length > 0) {
        this.validatorRef.refs[errors[0].key].$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    },
    resetForm () {
      this.setupModel()
      this.validatorRef.reset()
    },
    onSubmit () {
      this.validatorRef.validate().then(success => {
        if (!success) {
          this.focusOnErrors()
        }

        this.$emit('submit', {
          form: this,
          formRef: this.$refs.form,
          validator: this.validatorRef
        } as FormSubmitObject)
      })
    }
  }
})
